import {
  shouldReportTampering,
  startCheckIfActivePolling,
} from './actions/engineActions';
import { ensureStoresAreInit } from './storage/stores';
import {
  restoreContentIfNeeded,
  setupContentHiding,
  shouldEnableContentHiding,
} from './contentHider/contentHiderScript';
import { identifySentry, setupSentry } from './lib/vendor/sentry';
import { captureException } from './helper/sentry';

/**
 * Initialise the content script asynchronously every time a web page loads
 *
 * @remarks
 * WARNING! Be careful with the imports you add here! Content Scripts do not have access to all Chrome API,
 * so if the import has a dependency on a not allowed API, this could lead to runtime errors.
 */
export const init = async () => {
  // Initialize storage, since content_scripts are executed in an isolated world, and we need it to do some checks.
  await ensureStoresAreInit();

  // Set deviceUID and accountUID for Sentry events as soon as the storage is ready to get them
  identifySentry();

  // Restore content if it's not needed to hide it
  if (!shouldEnableContentHiding()) {
    restoreContentIfNeeded();
  }

  if (shouldReportTampering()) {
    // Detect if extension has been tampered and report it
    startCheckIfActivePolling();
  }
};

/* Run content script
 *
 * @remarks
 *
 * - WARNING! Any initialization done here might be needed to be placed in the content script and custom pages as well.
 * - Sentry is initialized here with a global errors filter to avoid reporting noise from websites that might use Sentry as well.
 */
setupSentry({
  filterGlobalErrors: true,
});

// Since global error catching is disabled, we need to use a try/catch to be able to report our errors.
try {
  // Hide page content before anything else.
  // We need to do it here because the storage can take a while to load sometimes,
  // and we don't want to show the page content.
  setupContentHiding();

  init();
} catch (error) {
  console.error(error);
  captureException(error as Error);
}
